// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"2883":"9c0062549e1ef0ab30cf","4792":"9c0062549e1ef0ab30cf"}[chunkId] + ".chunk.css";
};